// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'house-person';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M14.625 7.313a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5zm2.813 5.625V11.25a2.812 2.812 0 1 0-5.625 0v1.688h1.125l.562 4.5h2.25l.563-4.5zM2.813 3.211v6.351a1.125 1.125 0 0 0 1.124 1.125h4.5a1.125 1.125 0 0 0 1.126-1.125v-6.35' />
    <path d='M10.688 4.225 6.938.85a1.125 1.125 0 0 0-1.504 0L.562 5.237' />
  </g>
);

export const viewBox = '0 0 18 18';
